import React from "react";
//#region types
import { WintUtilsWebApi } from "wint-api-client/dist/types";
import { AllTodoListViewProps } from "models/propTypes/todoPropTypes";
import { TodoFormTypes } from "models/formTypes";
//#endregion
//#region components
import { useFilterContext } from "components/common";
import { ToDoListViewInner } from "components/todos";
import { useTodoService } from "serviceHooks";
//#endregion

const AllToDoListView: React.FC<AllTodoListViewProps> = (props) => {
  const todoService = useTodoService();
  const { filter } = useFilterContext<TodoFormTypes.Filter>();

  const filterFunc = (baseFilter: WintUtilsWebApi.Filter, key?: number) => {
    if (baseFilter.orderByProperty !== "Urgency") {
      baseFilter.thenByProperty = "Urgency";
      baseFilter.thenByDescending = true;
    }

    return todoService.reportFilter(baseFilter, key, {
      ...(filter ?? {}),
    });
  };

  return <ToDoListViewInner reloadKey={props.reloadKey} filter={filterFunc} />;
};

export default AllToDoListView;
